<template>
  <div class="followed-closets" ref="self-main">

    <div class="subcategories-list fs-14px">
      <div class="subcategories-item" :class="{'active': this.currentSubcategory === 'outfit'}" @click="toggleSubcategory('outfit')">好友的穿搭</div>
      <div class="subcategories-item" :class="{'active': this.currentSubcategory === 'closet'}" @click="toggleSubcategory('closet')">好友的衣櫥</div>
    </div>

    <FriendOutfits v-if="this.currentSubcategory === 'outfit'" :router-view-height="routerViewHeight" />

    <FriendCloths v-if="this.currentSubcategory === 'closet'" :router-view-height="routerViewHeight" />

  </div>
</template>

<script>
import { mapActions } from 'vuex';
import FriendOutfits from "@/views/share/FriendOutfits.vue";
import FriendCloths from "@/views/share/FriendCloths.vue";

export default {
  name: 'FollowedClosets',
  data() {
    return {
      readingBusyName: 'ReadingFollowedClosets',

      init: false,

      currentSubcategory: 'outfit',
      homeOutfitSerials: [],
      nowLoadCount: 6,
    };
  },
  props: {
    // scrollTop: {
    //   type: Number,
    // },
    routerViewHeight: {
      type: Number,
    }
  },
  components: {
    FriendOutfits, FriendCloths,
  },
  computed: {

  },
  watch: {
    // scrollTop(val) {
    //   this.scrollEvent(val);
    // },
  },
  async mounted() {
  },
  methods: {
    ...mapActions(['showMsgModal', 'appendComponentBusy', 'clearComponentBusy', 'appendErrorMsg', 'setAddFriendShow']),

    toggleSubcategory(name) {
      this.currentSubcategory = name;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/basic";
.followed-closets {
  display: flex;
  flex-direction: column;
  padding: 0 0 1rem;
  .subcategories-list {
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
    gap: 1rem;
    background: $color-white;
    padding: 1rem 0 .5rem;
    .subcategories-item {
      position: relative;
      padding-bottom: .25rem;
      &.active::after {
        position: absolute;
        bottom: 0;
        left: 0;
        content: '';
        height: 0;
        width: 100%;
        border-bottom: 2px solid $color-main-orange;
      }
    }
  }
}
  .share {
    padding: 1rem 0;
  }

  .add-friend-btn {
    border: none;
    border-radius: .5rem;
    background-color: var(--main-yellow);
    padding: .3rem;
    /* text-align: center; */
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-appearance: none;
    width: 100%;
    color: #fff;
  }

  .add-friend-btn>img {
    display: block;
    margin-right: .5rem;
    width: 20px;
    height: 20px;
  }

  .public-closet-list {
    padding: 1rem 0;
  }

  .public-closet-list h2 {
    font-size: 18px;
    font-weight: 1000;
    color: var(--text-dark);
  }

  .snippest-block {
    display: block;
    padding: 1rem;
    border-radius: 1rem;
    box-shadow: 3px 3px 2px 0 #EEEEEE;
    margin-bottom: .5rem;
  }

  .snippest-block:hover {
    text-decoration: none;
  }
</style>
<style lang="scss">
@import "../../assets/scss/basic";
.followed-closets {

}
</style>
